module.exports = __webpack_public_path__ + "static/media/slices_heart_sm.a73dd1e3.png";